const randomArray = (betweenFrom, betweenTo) => [
  ...Array(Math.floor(Math.random() * betweenTo) + betweenFrom).keys(),
];

export { randomArray };
